import client from '../client';
import { exportFile } from '../requestDownloadFile';

export default {
  getUploadReportsList: data => {
    return client.get('publisher/associate/report/batch/list', { params: data }).then(res => res.data);
  },
  getUploadReportsDetail: data => {
    return client.get('publisher/associate/report/list', { params: data }).then(res => res.data);
  },
  getUploadReportsDetailV2: data => {
    return client.get('publisher/associate/report/list', { params: data ,isV2: true}).then(res => res.data);
  },
  uploadReport: data => {
    return client.post('publisher/associate/report/upload', data).then(res => res.data);
  },
  uploadReportV2: data => {
    return client
      .post('publisher/associate/report/upload', data, { isV2: true })
      .then(res => res.data);
  },
  getAssociateBrandList: data => {
    return client.get('publisher/associate/brand', { params: data }).then(res => res.data);
  },
  getAssociateBrandDetail: data => {
    return client.get('publisher/associate/brand/commission/detail', { params: data }).then(res => res.data);
  },
  exportAssociate: data => {
    return exportFile('publisher/product/associate/export', data.qs, data.fileName);
  },
  getAssociateCampaignList: data => {
    return client.get('publisher/cc/campaigns/list', { params: data }).then(res => res.data);
  },
  // publisher/cc/campaigns/{campaignId}/products
  getAssociateCampaignProductsList: data => {
    return client.get(`publisher/cc/campaigns/${data.campaignId}/products`, { params: data }).then(res => res.data);
  },
}